const $ = jQuery;

export default class ArchiveAccessoriesRoute {
  constructor() {
    this.addEvents();
    this.modifyDOM();
  }

  addEvents() {
    $('body').on('click', '.js-filter-accessories', this.filterAccessories.bind(this));
    $('.accordion .accordionToggle, .accordion .title').on('click', this.accordionToggle.bind(this))
  }

  modifyDOM() {
    this.toggleFilterAndCategory();
  }

  toggleFilterAndCategory() {
    const search = window.location.search;
    const category = this.getUrlParameter(search, 'category');
    const section = this.getUrlParameter(search, 'section');

    if (section.length > 0) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#" + section).offset().top - 120
      }, 1000);
    }

  }

  accordionToggle(e) {
    const $el = $(e.currentTarget);
    const $accordion  = $el.closest('.accordion');
    const $filter = $('.js-filter-accessories.active');

    this.pushUrl($filter ,$accordion)
  }

  filterAccessories(e) {
    const $el = $(e.currentTarget);
    const target = $el.attr('href');
    const $accordion  = $('.accordion.active');

    $('.filter-accessories__item').removeClass('active');
    $el.addClass('active');

    if (target === '#') {
      $('.infoAccordions').removeClass('hidden');
    } else {
      $('.infoAccordions').addClass('hidden');
      $(target).removeClass('hidden');
    }

    this.pushUrl($el ,$accordion);

    return false;
  }

  pushUrl($filterElement, $accordionElement) {
    let baseUrl   = window.location.origin + window.location.pathname;
    const section  = $accordionElement.length > 0 ? $accordionElement.attr('id') : false;
    const category  = $filterElement.length > 0 ? $filterElement.data('id') : false;

    if (section && category) {
      history.pushState({}, "", baseUrl + '?category=' + category + '&section=' + section);
    } else if (section) {
      history.pushState({}, "", baseUrl + '?section=' + section);
    } else if (category) {
      history.pushState({}, "", baseUrl + '?category=' + category);
    }
  }

  getUrlParameter(url, parameter) {
    parameter = parameter.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?|&]' + parameter.toLowerCase() + '=([^&#]*)');
    var results = regex.exec('?' + url.toLowerCase().split('?')[1]);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
}
